<template>
    <section>
        <!-- <span style="border: 0 0 0;" v-for="(word, index) in text.split(' ')" :key="index">
            <span v-if="annotationsList2.includes(word)" @click.on="removeAnnotation(annotationsList2.indexOf(word))">
                <b-tag
                :closable="true"
                @close="removeAnnotation(index)"><b>PERSON</b>&nbsp;{{ word }}</b-tag>&nbsp;
            </span>
            <span v-else @click.on="onTextClick(index)" @mouseup="onTextSelection">
                {{ word }}
            </span>
        </span> -->
        
            
            <!-- <br><br>
            <span @click.on="onTextClick(index)" @mouseup="onTextSelection">
                    <span v-html="highlight(text, annotationsList)"></span>
            </span> -->
                
            <!-- :style="{ left: left+'px'}" -->
            <span style="border: 0 0 0;
    border: none;
    outline: none;" v-for="(word, index) in text.split(' ')" :key="index">
                        <span v-if="annotationsList2.includes(word)">
                            <b-tag
                            :closable="true"
                            @close="annotationsList2.indexOf(word)"><b>PERSON</b>&nbsp;{{ word }}</b-tag>&nbsp;
                        </span>
                        <span v-else @click.on="onTextClick(index)" @mouseup="onTextSelection">
                            {{ word }}
                        </span>
                    </span>
            <!-- <b-dropdown style="border: 0 0 0;display: block;
    border: none;
    outline: none;" class="is-pulled-leftx" aria-role="list">
                <template #trigger="{ selectedText }" style="border: 0 0 0;display: block;
    border: none;
    outline: none;">
                    
                </template>
                <b-dropdown-item>Annotate <b>{{ selectedText }}</b> as</b-dropdown-item>
                <b-dropdown-item separator></b-dropdown-item>
                <b-button :value="e" @click="addAnnotation(e)" v-for="e in annotations">{{ e }}</b-button>
                <b-dropdown-item aria-role="listitem" @click="closeSelection();">Close</b-dropdown-item>
            </b-dropdown> -->


            <hr>
            <span :key="r" v-for="r in highlight(text, annotationsList)">
                <span v-html="r"></span>
            </span>
            
            
            
      <!-- <b-field style="cursor: pointer;">
        <b-input
          style="cursor: pointer;"
          v-model="text"
          type="textarea"
          rows="2"
          placeholder="Enter text to be annotated"
          ref="textArea"
          @mouseup="onTextSelection"
          
        />
      </b-field> -->
      
      <p>Selected: {{  selectedInfo }}</p>
      <b-field>
        <!-- @click.on="onTextClick(index)" -->
      <span
        v-for="(word, index) in text.split(' ')">
        <p
            :key="index"
            
            @mouseup="onTextSelection"
        >
            <!-- <span :class="{'has-text-primary': annotationsList2.includes(word)}"> -->
            <span v-if="annotationsList2.includes(word)">
                <b-tag
                :closable="true"
                @close="removeAnnotation(index)"><b>PERSON</b>&nbsp;{{ word }}</b-tag>&nbsp;
            </span>
            <span v-else>
                {{ word }}&nbsp;
            </span>
        </p>
      </span>
      
    </b-field>
    {{  annotationsList }}
    <br><br><br>
      {{  selectedText }}
      <b-field>
        <b-select
              v-model="selectedAnnotation"
              placeholder="Select Entity"
              @mouseenter.native="showAnnotations = true"
              @mouseleave.native="showAnnotations = true"
              @input="addAnnotation">
              <option :value="e" v-for="e in annotations">{{ e }}</option>
            </b-select>
      </b-field>

      <b-field>
        <b-taglist>
          <b-tag
            v-for="(annotation, index) in annotationsList"
            :key="index"
            type="is-primary"
            size="is-medium"
            :closable="true"
            @close="removeAnnotation(index)"
          >
            {{ annotation.text }} ({{ annotation.label}})
          </b-tag>
        </b-taglist>
      </b-field>
      
    </section>
    
  </template>
  
  <script>
  

  export default {
    data() {
      return {
        text: 'IBM Settles Part of Giant Pension Lawsuit NEW YORK (Reuters) - International Business Machines Corp.',
        selectedAnnotation: '',
        annotations: [
          'Person',
          'Location',
          'Organization',
          'Unigram',
          'Bigram',
          'Trigram'
        ],
        annotationsList2: ["NEW YORK", "Reuters"],
        annotationsList: [{ label: "Location", text: "NEW YORK" }, { label: "Organization", text: "Reuters" }],
        showAnnotations: false,
        selectedText: '',
        selected: null,
        selectedInfo: null,
        viewMenu: false,
        top: '0',
        left: '0'
      };
    },
    components: {
      
    },
    filters: {
            pretty: function(value) {
                console.log(value)
                return JSON.stringify(value, null, 2);
            }
        },
    mounted(){
        
        // window.addEventListener("mouseup", this.onTextSelection);
        // window.addEventListener("mouseup", e => {
        //     alert(e)
        // })
    },
    methods: {
        word_replace(text){
            return text
        },
        highlight(text, annotations) {
            
            let actionable_text = text

            if (annotations.length < 1)
                return text

            let actionable = []
            let highlight = []

            text.split(' ').forEach( async (word, index) => {
                actionable_text = actionable_text.replace(new RegExp(word, "gi"), match => {
                    return `${match}`
                })

                actionable.push(actionable_text)
            })

            let highlight_text = actionable.slice(-1).join(' ')
            
            annotations.forEach(async (r, index) => {
                highlight_text = highlight_text.replace(new RegExp(r.text, "gi"), match => {
                    return `<span @on.click="alert(2)" style="margin-bottom: 5px" data-entity="${r.label.toLowerCase()}">${match} <span class='entities-type'><b>${r.label}</b></span></span>`;
                    // return `<b-tag :closable="true"
                    //         data-entity="${r.label.toLowerCase()}"
                    //         @click="removeAnnotation(${index})">${match}<span class='entities-type'><b>${r.label}</b></span></b-tag>`
                });
                
                highlight.push(highlight_text)
            });

            
            
            return highlight.slice(-1)
        },
      closeSelection(){
        this.selectedText = false
      },
      onTextSelection(e) {
        this.viewMenu = true
        let tokens = this.text.replace(/(\r\n|\n|\r)/gm, "");
        this.selected = window.getSelection()
        this.selectedText = this.selected.toString()
        this.selectedText = this.selectedText.replace(/(\r\n|\n|\r)/gm, "");
        
        let start = tokens.indexOf(this.selectedText)
        let end = start + this.selectedText.length

        this.selectedInfo = {
            start: start,
            end: end,
            text: this.selectedText
        };

        this.top = e.pageX;
        this.left = e.pageY;
        alert('x:',x,' y:', y)
        
      },
      onTextClick(index) {
        this.viewMenu = true
        let tokens = this.text.replace("\n", "").split(" ")
        let textArray = this.text.split(' ');
        this.selectedText = textArray[index]
        let start = tokens.indexOf(this.selectedText)
        let end = start + this.selectedText.length
        this.selectedInfo = {
            start: start,
            end: end,
            index: index,
            text: this.selectedText
        };
      },
      addAnnotation(selectedAnnotation) {
        this.selectedAnnotation = selectedAnnotation

        if (!this.selectedAnnotation) return;
        if (this.selectedText) {
          this.annotationsList.push({label: this.selectedAnnotation, text: this.selectedText});
          this.annotationsList2.push(`${this.selectedText}`);
          this.selectedText = '';
        } else {
          this.annotationsList.push({label: this.selectedAnnotation, text: this.selectedText});
          this.annotationsList2.push(`${this.selectedText}`);
        }
        this.selectedAnnotation = '';
        this.showAnnotations = false;
      },
      removeAnnotation(index) {
        alert(index)
        
        this.annotationsList.splice(index, 1);
        this.annotationsList2.splice(index, 1);
      }
    }
  };
  </script>
  
  